import { useDashboardFeatureFlags } from '@components';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { HeadContent, SaveShortcutListener } from '@fourthwall/components';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { Formik } from 'formik';
import React from 'react';
import { validationSchema } from './consts';
import { useDomain } from './hooks/useDomain';
import { ClaimDomain } from './modules/ClaimDomain';
import { CustomDomain } from './modules/CustomDomain';
import { InternalDomain } from './modules/InternalDomain';
export const Domain = () => {
    const { initialValues, handleSubmit } = useDomain();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Domain \u2013 Settings" }),
        React.createElement(Formik, { initialValues: initialValues, validationSchema: validationSchema, enableReinitialize: true, onSubmit: handleSubmit }, ({ dirty, isValid, isSubmitting, submitForm, resetForm }) => (React.createElement(React.Fragment, null,
            React.createElement(CustomDomain, null),
            dashboardFeatureFlags.subscriptions.enabled && React.createElement(ClaimDomain, null),
            React.createElement(InternalDomain, null),
            React.createElement(SaveShortcutListener, { disabled: !dirty, onSave: submitForm }),
            React.createElement(ConfirmBar, { isOpen: dirty, isLoading: isSubmitting, onConfirm: submitForm, onCancel: resetForm }),
            React.createElement(LeavingGuard, { when: dirty, isValid: isValid, onSave: submitForm }))))));
};
